<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <main class="main main--has-floating-buttons">
    <card v-if="hasLicense('CashBook')" :title="$t('pageCashBook.card.cashBook')" cols="12" min-height="350px">
      <hm-card-inner id="date-selection">
        <hm-col :grid="true" cols="12" class="z-index40">
          <hm-input-date v-model="date"
                         :label="$t('pageCashBook.date')"
                         :max-date="today"
                         cols="12 2@tablet 2@desktop 1@hd"
                         name="date" />
          <hm-col cols="12 8@tablet 8@desktop 6@hd start-5@tablet start-5@desktop start-7@hd" class="hidden@mobile">
            <div class="button-row">
              <hm-button class="" cols="1" icon-left="back-3" @click="updateDate(-365)">1 Y</hm-button>
              <hm-button class="" cols="1" icon-left="back-2" @click="updateDate(-21)">21 D</hm-button>
              <hm-button class="" cols="1" icon-left="back-1" @click="updateDate(-7)">7 D</hm-button>
              <hm-button class="hidden visible-flex@desktop visible-flex@hd" cols="1" icon-left="back-1" @click="updateDate(-1)">1 D</hm-button>
              <hm-button class="btn--today" cols="1" @click="updateDate(0)">{{ $t('pageRoomplan.today') }}</hm-button>
              <hm-button class="hidden visible-flex@desktop visible-flex@hd" cols="1" icon-right="forward-1" @click="updateDate(1)">1 D</hm-button>
              <hm-button class="" cols="1" icon-right="forward-1" @click="updateDate(7)">7 D</hm-button>
              <hm-button class="" cols="1" icon-right="forward-2" @click="updateDate(21)">21 D</hm-button>
              <hm-button class="" cols="1" icon-right="forward-3" @click="updateDate(365)">1 Y</hm-button>
            </div>
          </hm-col>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner :full-size="true">
        <hm-table
          :hover="false"
          columns="7"
          min-width="450px"
          grid-template-columns="minmax(9rem, 1fr) minmax(9rem, 1fr) minmax(10rem, 2fr) minmax(9rem, 1fr) minmax(9rem, 1fr) minmax(12rem, 2fr) 12rem">
          <template slot="table-head">
            <div class="hm-table__th">{{ $t('pageCashBook.entries.date') }}</div>
            <div class="hm-table__th">{{ $t('pageCashBook.entries.dateTime') }}</div>
            <div class="hm-table__th">{{ $t('pageCashBook.entries.label') }}</div>
            <div class="hm-table__th">{{ $t('pageCashBook.entries.type') }}</div>
            <div class="hm-table__th">{{ $t('pageCashBook.entries.user') }}</div>
            <div class="hm-table__th text-right">{{ $t('pageCashBook.entries.amount') }}</div>
            <div class="hm-table__th text-right"></div>
          </template>
          <template slot="default">
            <template v-if="isEmpty(data.entries)">
              <div class="hm-table__td col-7">{{ $t('pageCashBook.noCashMovements', { date: $options.filters.toDate(date) }) }}</div>
            </template>
            <template v-for="row in data.entries">
              <div class="hm-table__td">{{ row.businessDate | toDate }}</div>
              <div class="hm-table__td">{{ row.date | toLocalDateTime }}</div>
              <div class="hm-table__td">
                {{ row.label }}
                <template v-if="row.reference.parentId != null && (row.reference.parentId.type === 'RoomReservation' || row.reference.parentId.type === 'GuestProfile')">
                  ({{ $t(`EntityType.${row.reference.parentId.type}`) }} #{{ row.reference.parentId.id | id2number }})
                </template>
              </div>
              <div v-if="row.cancelled && !isNil(row.cancellationReference)" class="hm-table__td">{{ $t('pageCashBook.type.cancellation') }}</div>
              <div v-else-if="row.type === 'Revenue'" class="hm-table__td">{{ $t('pageCashBook.type.revenue') }}</div>
              <div v-else class="hm-table__td">{{ $t('pageCashBook.type.other') }}</div>
              <div class="hm-table__td hm-table__td--no-hover">{{ row.user }}</div>
              <div v-if="isNil(row.foreignAmount) || row.foreignAmount === 0" class="hm-table__td text-right">{{ row.amount | toCurrency }} {{ hotelSettings.details.currency }}</div>
              <div v-else class="hm-table__td text-right">{{ row.foreignAmount | toCurrency }} {{ row.foreignCurrency }}</div>
              <div class="hm-table__td hm-table__td--icon">
                <span v-if="canCancelEntry(row)" class="quick-action-button" @click="cancelEntry(row.id)">
                  <icon icon="close" />
                </span>
                <span v-if="hasLicense('EU_DE_Registrierkasse')" class="quick-action-button" @click="printReceipt(row)">
                  <icon icon="receipt" />
                </span>
                <span v-if="hasLicense('EU_AT_Registrierkasse') && row.type === 'Revenue'" class="quick-action-button" @click="printReceipt(row)">
                  <icon icon="receipt" />
                </span>
              </div>
            </template>
            <template v-for="(total, currency) in data.totalByCurrency">
              <div class="hm-table__td hm-table__td--no-hover text--bold">{{ data.date | toDate }}</div>
              <div class="hm-table__td hm-table__td--no-hover text--bold">&nbsp;</div>
              <div class="hm-table__td hm-table__td--no-hover text--bold col-3">{{ $t('pageCashBook.entries.dailyTotal') }} ({{ currency }})</div>
              <div class="hm-table__td hm-table__td--no-hover text--bold text-right">{{ total | toCurrency }} {{ currency }}</div>
              <div class="hm-table__td hm-table__td--no-hover text--bold"></div>
            </template>
            <template>
              <div class="hm-table__td hm-table__td--no-hover text--bold col-7"></div>
              <template v-for="row in cashCheck">
                <div v-if="date === today" class="hm-table__td hm-table__td--no-hover text--bold">&nbsp;</div>
                <div v-else class="hm-table__td hm-table__td--no-hover text--bold">{{ date | toDate }}</div>
                <div v-if="date === today" class="hm-table__td hm-table__td--no-hover text--bold">{{ new Date() | toLocalDateTime }}</div>
                <div v-else class="hm-table__td hm-table__td--no-hover text--bold"></div>
                <div class="hm-table__td hm-table__td--no-hover text--bold col-3">{{ $t('pageCashBook.entries.cashCheck') }} ({{ row.currency }})</div>
                <div class="hm-table__td hm-table__td--no-hover text--bold text-right">{{ row.total | toCurrency }} {{ row.currency }}</div>
                <div class="hm-table__td hm-table__td--no-hover text--bold"></div>
              </template>
            </template>
          </template>
        </hm-table>
      </hm-card-inner>
    </card>

    <modal v-if="showAddCashEntry !== false"
           :close-on-click-outside="false"
           :hide-on-submit="false"
           :title="$t('pageCashBook.card.addEntry')"
           :confirm-label="$t('pageCashBook.addEntry')"
           :hint="$moment().format('YYYYMMDD') !== date ? $t('pageCashBook.addCashEntry.hintAddEntry') : null"
           :button2-disabled="() => !canAddEntry"
           @confirm="addCashEntry()"
           @cancel="showAddCashEntry=false">
      <hm-card-inner min-height="35.8rem">
        <hm-col :grid="true" cols="12">
          <hm-input-date v-model="newEntry.date"
                         v-if="!['DE'].includes(hotelSettings.details.countryCode)"
                         :label="$t('pageCashBook.addCashEntry.date')"
                         :min-date="$moment().add(-45, 'days').format('YYYYMMDD')"
                         name="newEntry.date" />
          <hm-input-select v-model="newEntry.cashBookEntryType"
                           :label="$t('pageCashBook.addCashEntry.cashBookEntryType')"
                           :disabled-options="['Revenue','DifferenzSollIst',cashCheckToday.length > 0 ? 'Anfangsbestand' : null]"
                           :parent-errors="errors"
                           name="newEntry.cashBookEntryType"
                           enum-name="CashBookEntryType"
                           @blur="$v.$touch()"
          />
          <span class="info-text col-12" v-if="!isNil(newEntry.cashBookEntryType)"><b>{{ $t(`CashBookEntryType.${newEntry.cashBookEntryType}`) }}:</b> {{ $t(`EnumExplanation.CashBookEntryType.${newEntry.cashBookEntryType}`) }}</span>
          <template v-if="newEntry.cashBookEntryType != null">
            <hm-input-money v-model="newEntry.amount"
                            :currency="hotelSettings.details.currency"
                            :label="$t('pageCashBook.addCashEntry.amount')"
                            :parent-errors="errors"
                            name="newEntry.amount"
                            cols="6"
                            @blur="$v.$touch()"
            />
            <hm-input :label="$t('pageCashBook.addCashEntry.label')"
                      :parent-errors="errors"
                      v-model="newEntry.label"
                      name="newEntry.label"
                      cols="12"
                      @blur="$v.$touch()"
            />
          </template>
        </hm-col>
      </hm-card-inner>
    </modal>

    <modal v-if="showCashBalanceDifference !== false"
           :close-on-click-outside="false"
           :hide-on-submit="false"
           :title="$t('pageCashBook.card.cashBalanceDifference')"
           :confirm-label="$t('pageCashBook.confirmCashBalanceDifference')"
           @confirm="confirmCashBalanceDifference"
           @cancel="showCashBalanceDifference=false">
      <template v-for="row in cashCheck">
        <hm-card-inner :title="row.currency" :key="row.currency">
          <hm-input-money v-model="cashBalanceActual[row.currency]"
                          :currency="row.currency"
                          :label="$t('pageCashBook.cashBalanceDifference.actualBalance')"
                          name="actualBalance"
                          cols="12 6@tablet 4@desktop 4@hd" />
          <hm-input-money v-model="row.total"
                          :currency="row.currency"
                          :label="$t('pageCashBook.cashBalanceDifference.expectedBalance')"
                          :disabled="true"
                          name="expectedBalance"
                          cols="12 6@tablet 4@desktop 4@hd" />
          <hm-input-money :value="cashBalanceActual[row.currency] - row.total"
                          :currency="row.currency"
                          :label="$t('pageCashBook.cashBalanceDifference.balanceDifference')"
                          :disabled="true"
                          name="balanceDifference"
                          cols="12 6@tablet 4@desktop 4@hd" />
        </hm-card-inner>
      </template>
    </modal>

    <hm-floating-buttons id="actions" ref="floatingButtons">
      <template>
        <hm-floating-button :label="$t('pageCashBook.actions.addEntry')"
                            v-if="['DE'].includes(hotelSettings.details.countryCode) && $moment().format('YYYYMMDD') === date"
                            icon="plus"
                            color="blue"
                            @click="newEntry.date = null; showAddCashEntry = true;" />
        <hm-floating-button :label="$t('pageCashBook.actions.addEntry')"
                            v-else-if="!['DE'].includes(hotelSettings.details.countryCode) && $moment(date, 'YYYYMMDD').isAfter($moment().add(-45, 'days'))"
                            icon="plus"
                            color="blue"
                            @click="newEntry.date = date; showAddCashEntry = true" />
        <hm-floating-button v-if="$moment().format('YYYYMMDD') === date"
                            :label="$t('pageCashBook.actions.cashBalanceDifference')"
                            icon="balance-scale"
                            color="orange"
                            @click="clickShowCashBalanceDifference" />
      </template>
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import HmCol from '../lib/layout/HmCol';
import HmTable from '../lib/table/HmTable';
import HmCardInner from '../lib/layout/HmCardInner';
import { isNil, isEmpty, sortBy, sum, size } from 'lodash';
import ValidateMixin from '../../mixins/ValidateMixin';

export default {
  name: 'PageCashBook',
  components: { HmCardInner, HmCol, HmTable },

  mixins: [HotelmeisterMixin, ValidateMixin],

  data() {
    return {
      showAddCashEntry: false,
      showCashBalanceDifference: false,
      newEntry: {
        date: null,
        cashBookEntryType: null,
        amount: 0.0,
        label: null,
      },
      date: null,
      data: {
        date: null,
        entries: [],
        totalBaseCurrency: 0.0,
        totalByCurrency: {
        },
      },
      cashCheck: [],
      cashCheckToday: [],
      cashBalanceActual: {},
      cashBalanceDifference: {},
    };
  },

  validations: function () {
    if (isNil(this.newEntry.cashBookEntryType)) return {};

    return {
      newEntry: {
        cashBookEntryType: this.$hv__createValidators('required', this.$t('pageCashBook.addCashEntry.cashBookEntryType')),
        amount: this.$hv__createValidators(this.amountValidationRule, this.$t('pageCashBook.addCashEntry.amount')),
        label: this.$hv__createValidators(this.labelValidationRule, this.$t('pageCashBook.addCashEntry.label')),
      },
    };
  },

  computed: {
    today() {
      return this.$moment().format('YYYYMMDD');
    },
    canAddEntry() {
      if (isNil(this.newEntry.cashBookEntryType)) return false;
      if (this.newEntry.cashBookEntryType !== 'Anfangsbestand' && this.newEntry.amount === 0) return false;

      switch (this.newEntry.cashBookEntryType) {
        case 'Anfangsbestand':
        case 'Einzahlung':
        case 'Privateinlage':
          if (this.newEntry.amount < 0) return false;
          else break;
        case 'Auszahlung':
        case 'Lohnzahlung':
        case 'Privatentnahme':
          if (this.newEntry.amount > 0) return false;
          else break;
        case 'DifferenzSollIst':
        case 'Geldtransit':
          if (this.newEntry.amount === 0) return false;
          else break;
        default:
          break;
      }

      switch (this.newEntry.cashBookEntryType) {
        case 'Einzahlung':
        case 'Auszahlung':
          return !isEmpty(this.newEntry.label) && this.newEntry.label.length >= 3;
        default:
          break;
      }

      return true;
    },
    amountValidationRule() {
      switch (this.newEntry.cashBookEntryType) {
        case 'Anfangsbestand':
          return 'required|min_value:0';
        case 'Einzahlung':
        case 'Privateinlage':
          return 'required|min_value:0|not_value:0';
        case 'Auszahlung':
        case 'Lohnzahlung':
        case 'Privatentnahme':
          return 'required|max_value:0|not_value:0';
        case 'DifferenzSollIst':
          return 'required|max_value:0|not_value:0';
        case 'Geldtransit':
        default:
          return 'required|not_value:0';
      }
    },
    labelValidationRule() {
      switch (this.newEntry.cashBookEntryType) {
        case 'Einzahlung':
        case 'Auszahlung':
          return 'required|min_length:3';
        default:
          return '';
      }
    },
  },

  watch: {
    'newEntry.cashBookEntryType': function () {
      this.$v.$touch();
    },
    date: function () {
      this.loadData();
    },
  },

  created: function () {
    this.date = this.$moment().format('YYYYMMDD');
    this.loadData();
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.cashBook.get(this, this.date))
        .then((response) => {
          this.data = response.data.data;
          this.data.entries = sortBy(this.data.entries, 'date');
        })
        .catch((error) => {
          this.showMessages(error.response);
          this.data = {
            date: this.date,
            entries: [],
            totalBaseCurrency: 0.0,
            totalByCurrency: {
            },
          };
        });
      this.cashCheck = [];
      this.axios.get(this.serviceUrls.cashBook.getCashCheck(this, this.date))
        .then((response) => {
          this.cashCheck = response.data.data;
        })
        .catch((error) => {
          this.showMessages(error.response);
          this.cashCheck = [];
        });
      this.axios.get(this.serviceUrls.cashBook.getCashCheck(this, this.$moment().format('YYYYMMDD')))
        .then((response) => {
          this.cashCheckToday = response.data.data;
        })
        .catch((error) => {
          this.showMessages(error.response);
          this.cashCheckToday = [];
        });
    },
    printHTML(url) {
      this.$serviceBus.$emit('printHTML', url);
    },
    printReceipt(row) {
      // row.reference.parentId.id, row.reference.receiptHolderId
      const parentId = row.reference.parentId.id;
      const receiptHolderId = row.reference.receiptHolderId;
      let seq = 0;
      let receiptFlag = null;

      switch (this.hotelSettings.details.countryCode) {
        case 'AT':
          seq = row.reference.cancellation === true ? 1 : 0;
          break;
        case 'DE':
          if (row.type === 'Revenue') {
            seq = -1;
            receiptFlag = row.reference.cancellation === true ? 'CancellationReceipt' : 'PaymentReceipt';
          } else {
            seq = 0;
          }
          break;
        default:
          seq = 0;
          break;
      }

      receiptFlag = receiptFlag || 'SpecialReceipt';

      this.printHTML(
        window.getOldUIPath(
          this.hotelSettings.tenant.subdomain,
          this.hotelSettings.hotel.id,
          `/rest/ui/backend/hotel/${this.$route.params.hotelId}/print/receipt?parentId=${parentId}&receiptHolderId=${receiptHolderId}&receiptSeq=${seq}&receiptFlag=${receiptFlag}&displayMode=print`,
          window.getToken(this.$route.params.hotelId),
          null,
          true,
        ),
      );
    },
    addCashEntry() {
      this.axios.post(this.serviceUrls.cashBook.get(this, this.date), this.newEntry)
        .then((response) => {
          this.showSuccessMessage();
          this.showAddCashEntry = false;
          this.newEntry = {
            date: null,
            cashBookEntryType: null,
            amount: 0.0,
            label: null,
          };
          this.loadData();
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    updateDate: function (offset) {
      if (offset === 0) {
        this.date = this.today;
      } else {
        const tmpDate = this.$moment(this.date, 'YYYYMMDD').add(offset, 'days').format('YYYYMMDD');
        this.date = tmpDate > this.today ? this.today : tmpDate;
      }
    },
    clickShowCashBalanceDifference() {
      this.loadData();
      this.showCashBalanceDifference = true;
    },
    confirmCashBalanceDifference() {
      this.cashBalanceDifference = {};
      Object.keys(this.cashBalanceActual).forEach((currency) => {
        const cashBalanceActual = this.cashBalanceActual[currency];
        if (!isNil(cashBalanceActual)) {
          this.cashBalanceDifference[currency] = cashBalanceActual - this.cashCheck.find(it => it.currency === currency).total;
        }
      });

      let failed = false;

      Object.keys(this.cashBalanceDifference).forEach((currency) => {
        this.axios.post(this.serviceUrls.cashBook.get(this, this.date), {
          currency: currency,
          amount: this.cashBalanceDifference[currency],
          cashBookEntryType: 'DifferenzSollIst',
        })
          .then((response) => {
            this.showSuccessMessage();
            this.loadData();
          })
          .catch((error) => {
            this.showMessages(error.response);
            failed = true;
          });
      });

      this.cashBalanceActual = {};

      if (!failed) this.showCashBalanceDifference = false;
    },
    cancelEntry(entryId) {
      this.axios.delete(this.serviceUrls.cashBook.cancelEntry(this, this.date, entryId))
        .then((response) => {
          this.showSuccessMessage();
          this.loadData();
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    canCancelEntry(entry) {
      if (entry.cancelled === true) return false;

      switch (entry.type) {
        case 'Revenue':
        case 'Anfangsbestand':
          return false;
        default:
          break;
      }

      return true;
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';


  .button-row {
    display: grid;
    justify-content: left;
    @media (min-width: $br-tablet){
      justify-content: end;
    }
    grid-template-columns: repeat(7, auto);
    grid-column-gap: 1.5rem;

    @media (min-width: $br-desktop){
      grid-template-columns: repeat(9, auto);
    }
  }
</style>

<style lang="scss">
  @import '~styles/import';

</style>



// WEBPACK FOOTER //
// src/components/pages/PageCashBook.vue